import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ABC_AUTH_API } from 'app/core/auth-abc/auth-abc-api.interceptor';
import {
    AuditLog,
    AuditLogDetailResponse,
    AuditLogListResponse,
    AuditLogQueryParams,
} from 'app/core/interfaces/audit-log.interface';
import { Observable } from 'rxjs';

const httpOptions = {
    context: new HttpContext().set(ABC_AUTH_API, true),
};

@Injectable({
    providedIn: 'root',
})
export class AuditLogService {
    private readonly _http = inject(HttpClient);

    /**
     * Fetch paginated, filtered audit logs.
     * GET /admin/audit-logs
     */
    getAuditLogs(params: AuditLogQueryParams = {}): Observable<AuditLogListResponse> {
        let httpParams = new HttpParams();

        if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString());
        if (params.limit !== undefined) httpParams = httpParams.set('limit', params.limit.toString());
        if (params.performedById) httpParams = httpParams.set('performedById', params.performedById);
        if (params.performedByRole) httpParams = httpParams.set('performedByRole', params.performedByRole);
        if (params.activityType) httpParams = httpParams.set('activityType', params.activityType);
        if (params.affectedItemType) httpParams = httpParams.set('affectedItemType', params.affectedItemType);
        if (params.affectedItemId) httpParams = httpParams.set('affectedItemId', params.affectedItemId);
        if (params.startDate) httpParams = httpParams.set('startDate', params.startDate);
        if (params.endDate) httpParams = httpParams.set('endDate', params.endDate);

        return this._http.get<AuditLogListResponse>('admin/audit-logs', {
            ...httpOptions,
            params: httpParams,
        });
    }

    /**
     * Fetch a single audit log entry by ID.
     * GET /admin/audit-logs/:id
     */
    getAuditLogById(id: string): Observable<AuditLogDetailResponse> {
        return this._http.get<AuditLogDetailResponse>(`admin/audit-logs/${id}`, httpOptions);
    }
}
